import PropTypes from 'prop-types';
import React from 'react';
import ImmutablePropTypes from 'react-immutable-proptypes';

import { Layout, MainContent, Sidebar } from 'app/components/shared/DrawerLayout';
import ScreenReaderMessage from '@bibliocommons/base-screen-reader-message';
import { shelfShape, userIdentityShape } from '@bibliocommons/bc-prop-types';
import { Shelves } from '@bibliocommons/deprecated-base-icons';

import AvailabilityDetailOverlayContainer from 'app/components/shared/AvailabilityDetailOverlay/AvailabilityDetailOverlayContainer';
import accountShape from 'app/shapes/accountShape';
import EmptyShelf from '../EmptyShelf';
import ShelfBottomControls from '../ShelfBottomControls';
import ShelfFacets from '../ShelfFacets';
import ShelfHeader from '../ShelfHeader';
import ShelfImportAlert from '../ShelfImportAlert';
import ShelfList from '../ShelfList';
import ShelfTitleBar from '../ShelfTitleBar';
import ShelfUtilityBar from '../ShelfUtilityBar';
import EmptyContentPanel from '../../shared/EmptyContentPanel/EmptyContentPanel';

import './Shelf.scss';

export class Shelf extends React.PureComponent {
  renderImportAlert() {
    const {
      shelf,
      currentAccount,
      currentLibrary,
      importResult,
      localBranch,
      hiddenNotices,
      noticeActions,
      owner,
      shelfActions
    } = this.props;

    return (
      <ShelfImportAlert
        shelfName={shelf.get('name')}
        shelfOwner={owner}
        currentAccount={currentAccount}
        currentLibrary={currentLibrary}
        importResult={importResult}
        localBranch={localBranch}
        hiddenNotices={hiddenNotices}
        noticeActions={noticeActions}
        shelfActions={shelfActions}
      />
    );
  }

  renderResults() {
    const { shelf, activeFilters, owner, currentUserShelves, shelfActions } = this.props;

    if (shelf.get('items').size > 0) {
      const {
        currentLibrary,
        isFetching,
        printURL,
        bibs,
        ownerComments,
        ownerQuotations,
        ownerRatings,
        ownerTags,
        ownerVideos,
        iOwnThisSettings,
        ownerSimilarTitles,
        ownerPrivateNotes,
        ownerContentAdvisories,
        ownerAgeSuitabilities,
        ownerSummaries,
        commentsTransactions,
        quotationsTransactions,
        contentAdvisoriesTransactions,
        ageSuitabilitiesTransactions,
        summariesTransactions,
        tagsTransactions,
        similarTitlesTransactions,
        privateNotesTransactions,
        iOwnThisTransactions,
        shelfTransactions,
        videosTransactions,
        videosActions,
        iOwnThisActions,
        availabilityDetailActions,
        commentsActions,
        quotationsActions,
        drawerActions,
        tagsActions,
        similarTitlesActions,
        privateNotesActions,
        contentAdvisoriesActions,
        ageSuitabilitiesActions,
        summariesActions,
        workflowActions,
        modalActions,
        handleAvailabilityLinkClick,
        trackContentCollectionMove
      } = this.props;

      return (
        <div>
          <ShelfUtilityBar
            activeFilters={activeFilters}
            isFetching={isFetching}
            pagination={shelf.get('pagination')}
            printURL={printURL}
            sortFields={shelf.getIn(['sort', 'fields'])}
            drawerActions={drawerActions}
          />
          <ShelfList
            currentLibrary={currentLibrary}
            owner={owner}
            shelf={shelf}
            bibs={bibs}
            currentUserShelves={currentUserShelves}
            commentsTransactions={commentsTransactions}
            quotationsTransactions={quotationsTransactions}
            tagsTransactions={tagsTransactions}
            privateNotesTransactions={privateNotesTransactions}
            shelfTransactions={shelfTransactions}
            videosTransactions={videosTransactions}
            iOwnThisTransactions={iOwnThisTransactions}
            similarTitlesTransactions={similarTitlesTransactions}
            contentAdvisoriesTransactions={contentAdvisoriesTransactions}
            ageSuitabilitiesTransactions={ageSuitabilitiesTransactions}
            summariesTransactions={summariesTransactions}
            ownerComments={ownerComments}
            ownerQuotations={ownerQuotations}
            ownerRatings={ownerRatings}
            ownerTags={ownerTags}
            ownerVideos={ownerVideos}
            ownerPrivateNotes={ownerPrivateNotes}
            ownerContentAdvisories={ownerContentAdvisories}
            ownerAgeSuitabilities={ownerAgeSuitabilities}
            ownerSummaries={ownerSummaries}
            iOwnThisSettings={iOwnThisSettings}
            ownerSimilarTitles={ownerSimilarTitles}
            commentsActions={commentsActions}
            availabilityDetailActions={availabilityDetailActions}
            quotationsActions={quotationsActions}
            tagsActions={tagsActions}
            similarTitlesActions={similarTitlesActions}
            privateNotesActions={privateNotesActions}
            contentAdvisoriesActions={contentAdvisoriesActions}
            ageSuitabilitiesActions={ageSuitabilitiesActions}
            summariesActions={summariesActions}
            videosActions={videosActions}
            iOwnThisActions={iOwnThisActions}
            shelfActions={shelfActions}
            workflowActions={workflowActions}
            modalActions={modalActions}
            handleAvailabilityLinkClick={handleAvailabilityLinkClick}
            trackContentCollectionMove={trackContentCollectionMove}
          />
          <ShelfBottomControls isFetching={isFetching} pagination={shelf.get('pagination')} />
        </div>
      );
    }

    return <EmptyContentPanel icon={<Shelves />} fetching={this.props.isFetching} />;
  }

  renderShelfSearch() {
    const { drawer, shelf, activeFilters, owner, shelfActions, currentUserShelves, shelfTransactions } = this.props;
    const totalCount = shelf.getIn(['pagination', 'count']);
    if (totalCount > 0 || activeFilters.size > 0) {
      const { drawerActions } = this.props;

      return (
        <div>
          <ShelfTitleBar
            owner={owner}
            shelfActions={shelfActions}
            currentShelfName={shelf.get('name')}
            currentUserShelves={currentUserShelves}
            currentShelfCount={totalCount}
            shelfTransactions={shelfTransactions}
          />

          <Layout open={drawer.get('open')}>
            <Sidebar sidebarClass="shelf-sidebar" drawerActions={drawerActions}>
              <ShelfFacets
                owner={owner}
                activeFilters={activeFilters}
                shelf={shelf}
                drawerActions={drawerActions}
                shelfActions={shelfActions}
              />
            </Sidebar>
            <MainContent mainClass="shelf-main-content">
              {this.renderImportAlert()}
              {this.renderResults()}
            </MainContent>
          </Layout>
        </div>
      );
    }

    return (
      <EmptyShelf
        owner={owner}
        shelf={shelf}
        currentUserShelves={currentUserShelves}
        shelfActions={shelfActions}
        shelfTransactions={shelfTransactions}
      >
        {this.renderImportAlert()}
      </EmptyShelf>
    );
  }

  render() {
    const { owner, pageTitle, shelf, summary } = this.props;

    return (
      <div className="cp-shelf container">
        <ShelfHeader owner={owner} summary={summary} currentShelfName={shelf.get('name')} />
        <ScreenReaderMessage className="shelf-page-title">
          <h1>{pageTitle}</h1>
        </ScreenReaderMessage>
        {this.renderShelfSearch()}
        <AvailabilityDetailOverlayContainer />
      </div>
    );
  }
}

const drawerShape = ImmutablePropTypes.mapContains({
  open: PropTypes.bool
});

const importResultShape = ImmutablePropTypes.mapContains({
  isFetching: PropTypes.bool,
  count: PropTypes.number,
  status: PropTypes.string
});

Shelf.propTypes = {
  currentAccount: accountShape,
  importResult: importResultShape,
  localBranch: PropTypes.string,
  currentLibrary: ImmutablePropTypes.map.isRequired,
  drawer: drawerShape.isRequired,
  isFetching: PropTypes.bool.isRequired,
  owner: userIdentityShape.isRequired,
  pageTitle: PropTypes.string.isRequired,
  printURL: PropTypes.string.isRequired,
  shelf: shelfShape.isRequired,
  activeFilters: ImmutablePropTypes.map.isRequired,
  summary: ImmutablePropTypes.map.isRequired,
  bibs: ImmutablePropTypes.map.isRequired,
  ownerRatings: ImmutablePropTypes.map.isRequired,
  ownerComments: ImmutablePropTypes.map.isRequired,
  ownerQuotations: ImmutablePropTypes.map.isRequired,
  ownerTags: ImmutablePropTypes.map.isRequired,
  ownerVideos: ImmutablePropTypes.map.isRequired,
  iOwnThisSettings: ImmutablePropTypes.map.isRequired,
  ownerSimilarTitles: ImmutablePropTypes.map.isRequired,
  ownerPrivateNotes: ImmutablePropTypes.map.isRequired,
  ownerContentAdvisories: ImmutablePropTypes.map.isRequired,
  ownerAgeSuitabilities: ImmutablePropTypes.map.isRequired,
  ownerSummaries: ImmutablePropTypes.map.isRequired,
  commentsTransactions: ImmutablePropTypes.map.isRequired,
  quotationsTransactions: ImmutablePropTypes.map.isRequired,
  tagsTransactions: ImmutablePropTypes.map.isRequired,
  videosTransactions: ImmutablePropTypes.map.isRequired,
  iOwnThisTransactions: ImmutablePropTypes.map.isRequired,
  similarTitlesTransactions: ImmutablePropTypes.map.isRequired,
  privateNotesTransactions: ImmutablePropTypes.map.isRequired,
  contentAdvisoriesTransactions: ImmutablePropTypes.map.isRequired,
  ageSuitabilitiesTransactions: ImmutablePropTypes.map.isRequired,
  summariesTransactions: ImmutablePropTypes.map.isRequired,
  shelfTransactions: ImmutablePropTypes.map.isRequired,
  hiddenNotices: ImmutablePropTypes.set.isRequired,
  currentUserShelves: ImmutablePropTypes.map.isRequired,
  availabilityDetailActions: PropTypes.objectOf(PropTypes.func).isRequired,
  commentsActions: PropTypes.objectOf(PropTypes.func).isRequired,
  drawerActions: PropTypes.objectOf(PropTypes.func).isRequired,
  quotationsActions: PropTypes.objectOf(PropTypes.func).isRequired,
  tagsActions: PropTypes.objectOf(PropTypes.func).isRequired,
  videosActions: PropTypes.objectOf(PropTypes.func).isRequired,
  iOwnThisActions: PropTypes.objectOf(PropTypes.func).isRequired,
  noticeActions: PropTypes.objectOf(PropTypes.func).isRequired,
  similarTitlesActions: PropTypes.objectOf(PropTypes.func).isRequired,
  privateNotesActions: PropTypes.objectOf(PropTypes.func).isRequired,
  contentAdvisoriesActions: PropTypes.objectOf(PropTypes.func).isRequired,
  ageSuitabilitiesActions: PropTypes.objectOf(PropTypes.func).isRequired,
  summariesActions: PropTypes.objectOf(PropTypes.func).isRequired,
  shelfActions: PropTypes.objectOf(PropTypes.func).isRequired,
  workflowActions: PropTypes.objectOf(PropTypes.func).isRequired,
  modalActions: PropTypes.objectOf(PropTypes.func),
  handleAvailabilityLinkClick: PropTypes.func,
  trackContentCollectionMove: PropTypes.func
};

export default Shelf;
